import { navigate } from '../router.js';
import { getTranslatedFields } from '../lib/i18n.js';
import { getState } from '../state.js';
import { getNodeColorFromTags } from '../lib/colorUtils.js';
import { formatDateValue } from '../lib/dateFormat.js';

interface ConceptCardData {
  slug: string;
  title: string;
  summary?: string | null;
  date_value?: string | null;
  crosslink_date_value?: string | null;
  relation_type?: string | null;
  relation_type_translations?: { lang: string; name: string }[];
  tags?: { color: string; name?: string }[];
  translations?: { lang: string; title: string; summary?: string | null; content?: string | null }[];
  content?: string | null;
}

function getTranslatedRelationType(concept: ConceptCardData): string | null {
  if (!concept.relation_type) return null;
  const { lang } = getState();
  if (lang && concept.relation_type_translations && concept.relation_type_translations.length > 0) {
    const normalizedLang = lang.toLowerCase();
    const tr = concept.relation_type_translations.find(t => t.lang.toLowerCase() === normalizedLang);
    if (tr) return tr.name;
  }
  return concept.relation_type;
}

export function renderConceptCard(parent: HTMLElement, concept: ConceptCardData): HTMLElement {
  const { title, summary } = getTranslatedFields(concept);
  const relationType = getTranslatedRelationType(concept);
  const tagColor = getNodeColorFromTags(concept.tags || [], 'hex') as string;

  const card = document.createElement('div');
  card.className = 'concept-card';
  card.style.setProperty('--card-color', tagColor);

  const crosslinkDate = formatDateValue(concept.crosslink_date_value);
  const conceptDate = formatDateValue(concept.date_value);
  const dateDisplay = crosslinkDate || conceptDate;

  card.innerHTML = `
    ${relationType ? `<div class="concept-card__relation">${relationType}</div>` : ''}
    <div class="concept-card__title">${title}</div>
    ${dateDisplay ? `<div class="concept-card__date" style="font-family: var(--font-mono); font-size: 0.7rem; color: var(--dim);">${dateDisplay}</div>` : ''}
    ${summary ? `<div class="concept-card__summary">${summary}</div>` : ''}
  `;

  card.addEventListener('click', () => navigate(`/concept/${concept.slug}`));
  parent.appendChild(card);
  return card;
}
